"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
var _exportNames = {
  create: true,
  deleteItem: true,
  getAll: true,
  getById: true,
  patch: true,
  update: true,
  APPLICATION_JSON: true
};
exports.APPLICATION_JSON = exports.update = exports.patch = exports.getById = exports.getAll = exports.deleteItem = exports.create = void 0;

var _create = _interopRequireDefault(require("./create"));

exports.create = _create.default;

var _deleteItem = _interopRequireDefault(require("./deleteItem"));

exports.deleteItem = _deleteItem.default;

var _GenericCRUD = require("./GenericCRUD");

Object.keys(_GenericCRUD).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  exports[key] = _GenericCRUD[key];
});

var _getAll = _interopRequireDefault(require("./getAll"));

exports.getAll = _getAll.default;

var _getById = _interopRequireDefault(require("./getById"));

exports.getById = _getById.default;

var _patch = _interopRequireDefault(require("./patch"));

exports.patch = _patch.default;

var _update = _interopRequireDefault(require("./update"));

exports.update = _update.default;
var APPLICATION_JSON = 'application/json';
exports.APPLICATION_JSON = APPLICATION_JSON;